/**
 * AI Studio Module Configuration
 * Self-contained configuration for the agent platform API
 */

export interface AgentPlatformConfig {
  apiUrl: string;
}

const agentPlatformUrls: { [key: string]: string } = {
  development: "http://localhost:3333/admin",
  test: "https://agents.test.introist.com/admin",
  production: "https://agents.introist.com/admin"
};

export const getAgentPlatformConfig = (): AgentPlatformConfig => {
  return {
    apiUrl: agentPlatformUrls[process.env.REACT_APP_ENV ?? "development"]
  };
};

export const agentPlatformConfig = getAgentPlatformConfig();
